import { useParams } from 'react-router-dom';
import { useEntityUrl, createRoute } from 'framework/routing';

const VENDORS_PATH = '/vendors';
const COMPLIANCE_SEGMENT = 'compliance';
const AGREEMENT_SEGMENT = 'agreement';
const DOCUMENTS_SEGMENT = 'documents';
const AGREEMENTS_SEGMENT = 'agreements';
const RELATED_INVOICES_SEGMENT = 'related-invoices';

export const getVendorsListUrl = () => VENDORS_PATH;

export const getVendorsRouterPath = () => `${VENDORS_PATH}/*`;

export const useVendorsRoute = () => {
  const baseRoutes = createRoute({ listRoute: VENDORS_PATH });

  return {
    ...baseRoutes,
    complianceRoute: `${baseRoutes.singleEntityRoute}/${COMPLIANCE_SEGMENT}`,
    agreementRoute: `${baseRoutes.singleEntityRoute}/${AGREEMENT_SEGMENT}`,

    documentsRoute: `${baseRoutes.singleEntityRoute}/${DOCUMENTS_SEGMENT}`,
    agreementsRoute: `${baseRoutes.singleEntityRoute}/${AGREEMENTS_SEGMENT}`,
    relatedInvoicesRoute: `${baseRoutes.singleEntityRoute}/${RELATED_INVOICES_SEGMENT}`,
  };
};

export const useVendorsUrl = () => {
  const baseUrls = useEntityUrl({
    baseLink: VENDORS_PATH,
  });

  // Forms
  const getComplianceVendorUrl = (id: string) => `${baseUrls.getSingleEntityUrl(id)}/${COMPLIANCE_SEGMENT}`;
  const getAgreementVendorUrl = (id: string) => `${baseUrls.getSingleEntityUrl(id)}/${AGREEMENT_SEGMENT}`;

  // Tabs
  const getDocumentsVendorUrl = (id: string) => `${baseUrls.getSingleEntityUrl(id)}/${DOCUMENTS_SEGMENT}`;
  const getVendorAgreementsUrl = (id: string) => `${baseUrls.getSingleEntityUrl(id)}/${AGREEMENTS_SEGMENT}`;
  const getRelatedInvoicesUrl = (id: string) => `${baseUrls.getSingleEntityUrl(id)}/${RELATED_INVOICES_SEGMENT}`;

  return {
    ...baseUrls,
    getComplianceVendorUrl,
    getRelatedInvoicesUrl,
    getDocumentsVendorUrl,
    getVendorAgreementsUrl,
    getAgreementVendorUrl,
  };
};

export const useVendorId = () => useParams<Dictionary<string>>().id!;
